export default {
    menu1: "維修服務",
    menu2: "文件貨物寄存",
    menu3: "文件貨物代送",
}